/**
 * Language utility functions
 */
import { AVAILABLE_LANGUAGES, DEFAULT_LANGUAGE } from '../../constants';
/**
 * Validates and normalizes a language code against AVAILABLE_LANGUAGES.
 * Returns the uppercase language code if valid, otherwise defaults to 'EN'.
 * 
 * @param languageCode - The language code to validate
 * @returns A valid uppercase language code
 */
export const normalizeLanguageCode = (languageCode?: string): string => {
  const code = languageCode?.toUpperCase();

  return code && Object.keys(AVAILABLE_LANGUAGES).includes(code) ? code : DEFAULT_LANGUAGE;
};
